var exports = {
  "DD": "title__SJZb6P",
  "MO": "menuOpen__OePrYN",
  "Qs": "content__07csa0",
  "Kk": "icon__JKKIU3",
  "Qq": "text__ox--tL",
};

module.exports = exports;
